import React from "react";

// Uses the supplied Daisy Does brand logo (script + daisy flower).
export const Logo = ({ className = "", height = 56, alt = "Daisy Does — practical help, calmly done" }) => (
  <img
    src="/daisy-does-logo-tight.png"
    alt={alt}
    style={{ height, width: "auto" }}
    className={`block select-none ${className}`}
    data-testid="brand-logo"
    draggable={false}
  />
);

// Kept for compatibility — anywhere that imported DaisyMark gets a small square mark.
export const DaisyMark = ({ size = 40, className = "" }) => (
  <img
    src="/favicon-512.png"
    alt=""
    style={{ width: size, height: size }}
    className={`block rounded-full ${className}`}
    aria-hidden="true"
    draggable={false}
  />
);

export default Logo;
